// extracted by mini-css-extract-plugin
module.exports = {"nextImage":"style_nextImage__cFWqB","loading":"style_loading__OKRWr","loaded":"style_loaded__BuIrX"};